import { useContext, useState, useRef } from 'react'

import NoteContext from '../../context/notes/NoteContext'

const AddNote = ({ showAlert }) => {
  const context = useContext(NoteContext)

  const { addNote } = context

  const [note, setNote] = useState({
    title: '',
    description: '',
    tag: 'General',
  })

  const val = useRef(null)
  const val2 = useRef(null)

  const onChange = (e) => {
    setNote({
      ...note,
      [e.target.name]: e.target.value,
    })

    if (e.target.name === 'title') {
      if (note.title.trim().length < 2) {
        val.current.classList.remove('d-none')
        val.current.classList.add('d-block')
      } else {
        val.current.classList.remove('d-block')
        val.current.classList.add('d-none')
      }
    }

    if (e.target.name === 'description') {
      if (note.description.trim().length < 4) {
        val2.current.classList.remove('d-none')
        val2.current.classList.add('d-block')
      } else {
        val2.current.classList.remove('d-block')
        val2.current.classList.add('d-none')
      }
    }
  }

  const handleClick = (e) => {
    e.preventDefault()

    addNote(note.title, note.description, note.tag)
    setNote({ title: '', description: '', tag: 'General' })

    showAlert('Note added successfully.', 'info')
  }

  return (
    <div className='container my-4'>
      <h1>Add a Note</h1>

      <form className='my-3'>
        <div className='form-group'>
          <label htmlFor='title'>Title</label>
          <input
            type='text'
            className='form-control'
            id='title'
            name='title'
            aria-describedby='title'
            // placeholder='Enter Title'
            onChange={onChange}
            value={note.title}
            minLength={3}
            required
          />
          <p className='text-danger d-none' ref={val}>
            Enter at least 3 characters
          </p>
        </div>

        <div className='form-group'>
          <label htmlFor='description'>Description</label>
          <input
            type='text'
            className='form-control'
            id='description'
            name='description'
            // placeholder='Description...'
            onChange={onChange}
            value={note.description}
            minLength={5}
            required
          />
          <p className='text-danger d-none' ref={val2}>
            Enter at least 5 characters
          </p>
        </div>

        <div className='form-group'>
          <label htmlFor='tag'>Tag</label>
          <input
            type='text'
            className='form-control'
            id='tag'
            name='tag'
            placeholder='Tag'
            onChange={onChange}
            value={note.tag}
          />
        </div>
        
        <button
          type='submit'
          className='btn btn-primary mt-2'
          onClick={handleClick}
          disabled={
            note.title.trim().length < 3 ||
            note.description.trim().length < 5 ||
            note.tag.trim().length === 0
          }
        >
          Add Note
        </button>
      </form>
    </div>
  )
}

export default AddNote
